import { cn, ghostAccentIconTileClass } from '@up2stay/up2promo-ui';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import {
  TEMPLATE_DETAIL_LABEL_CLASS,
  TEMPLATE_DETAIL_MUTED_CLASS,
  TEMPLATE_DETAIL_SECTION_TITLE_CLASS,
  TemplateDetailSectionCard,
} from '@/core/components/profile-templates/template-detail-section-card';

type TemplateOverviewSectionProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
  badge?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function TemplateOverviewSection({
  icon: Icon,
  title,
  description,
  badge,
  children,
  className,
}: TemplateOverviewSectionProps) {
  return (
    <TemplateDetailSectionCard className={className} contentClassName="gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2.5">
          <div
            className={cn(
              'flex size-8 shrink-0 items-center justify-center rounded-[var(--r-control)]',
              ghostAccentIconTileClass,
            )}
            aria-hidden
          >
            <Icon className="size-4" />
          </div>
          <h2 className={TEMPLATE_DETAIL_SECTION_TITLE_CLASS}>{title}</h2>
        </div>
        {description ? (
          <p className={TEMPLATE_DETAIL_MUTED_CLASS}>{description}</p>
        ) : null}
        {badge ? <div>{badge}</div> : null}
      </div>
      {children}
    </TemplateDetailSectionCard>
  );
}

type TemplateOverviewFieldProps = {
  id: string;
  label: string;
  hint?: string;
  children: ReactNode;
};

export function TemplateOverviewField({
  id,
  label,
  hint,
  children,
}: TemplateOverviewFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className={TEMPLATE_DETAIL_LABEL_CLASS}>
        {label}
      </label>
      {children}
      {hint ? (
        <p id={`${id}-hint`} className={TEMPLATE_DETAIL_MUTED_CLASS}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
